import { ReactNode } from "react";
import ActiveGameZoneScreen from "./ActiveGameZoneScreen";
import BottomNavigationBar from "./BottomNavigationBar";

interface ActiveGameZoneScreenWithNavigationProps {
  /** Контент/віджети екрану */
  children: ReactNode;
  /** Показувати навбар та блок затемнення знизу (за замовчуванням true) */
  showNavigation?: boolean;
}

/**
 * Компонент для екранів з активною зоною гри та навігацією.
 * Нащадок від ActiveGameZoneScreen, додає навігаційне меню та блок затемнення знизу.
 */
export default function ActiveGameZoneScreenWithNavigation({
  children,
  showNavigation = true,
}: ActiveGameZoneScreenWithNavigationProps) {
  return (
    <ActiveGameZoneScreen>
      {children}
      
      {showNavigation && (
        <>
          {/* Навігаційне меню - "літає" над контентом, завжди знизу */}
          <div className="bottom-navigation-container pointer-events-none absolute bottom-0 left-1/2 z-[1000] w-full max-w-[360px] min-w-0 -translate-x-1/2 select-none">
            <div className="pointer-events-auto select-none">
              <BottomNavigationBar />
            </div>
          </div>
          
          {/* Глобальний блок затемнення знизу */}
          <div className="pointer-events-none absolute bottom-0 left-0 z-[998] h-[25vh] w-full select-none bg-[linear-gradient(180deg,var(--color-black-alpha-0)_0.02%,var(--color-ink)_107.27%)]" />
        </>
      )}
    </ActiveGameZoneScreen>
  );
}
